export function isValidGoogleMeetLink(input: string) {
	return /^https:\/\/meet.google.com\/[a-z-]\/?/.test(input);
}
